import Vue from 'vue'
import Vuex from 'vuex'
import report from './modules/report/index'
import pdf from './modules/pdf/index'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    report,
    pdf,
  },
})
